class PromoBoxLiftKit extends HTMLElement {
  connectedCallback() {
    var _a, _b;
    if (this.initialized) return;
    this.initialized = true;
    this.hasDrawer = this.dataset.hasDrawer === "true";
    this.header = document.getElementById("shopify-section-header");
    this.anchor = document.querySelector("[data-lift-kit-promo-anchor]");
    this.openButton = this.querySelector("[data-lift-kit-promo-open]");
    this.overlay = this.querySelector("[data-lift-kit-promo-overlay]");
    this.panel = this.querySelector("[data-lift-kit-promo-panel]");
    this.closeButtons = this.querySelectorAll("[data-lift-kit-promo-close]");
    this.handleResize = this.updatePosition.bind(this);
    this.handleKeydown = (event) => {
      if (event.key === "Escape" && this.isOpen) this.setOpen(false);
    };
    if (this.hasDrawer) {
      (_a = this.openButton) == null ? void 0 : _a.addEventListener("click", () => this.setOpen(true));
      this.closeButtons.forEach((button) => button.addEventListener("click", () => this.setOpen(false)));
      (_b = this.overlay) == null ? void 0 : _b.addEventListener("click", (event) => {
        if (event.target === this.overlay) this.setOpen(false);
      });
      document.addEventListener("keydown", this.handleKeydown);
    }
    window.addEventListener("resize", this.handleResize);
    this.updatePosition();
    window.requestAnimationFrame(() => this.updatePosition());
  }
  disconnectedCallback() {
    if (this.hasDrawer) {
      document.removeEventListener("keydown", this.handleKeydown);
    }
    window.removeEventListener("resize", this.handleResize);
  }
  updatePosition() {
    var _a, _b, _c, _d, _e, _f, _g;
    const fallbackTop = window.matchMedia("(min-width: 768px)").matches ? 150 : 96;
    const headerBottom = ((_a = this.header) == null ? void 0 : _a.getBoundingClientRect().bottom) ?? 0;
    const anchorTop = (_b = this.anchor) == null ? void 0 : _b.getBoundingClientRect().top;
    const nextTop = Math.max(headerBottom + 12, anchorTop ?? fallbackTop, fallbackTop);
    const preferredPanelHeight = window.matchMedia("(min-width: 600px)").matches ? 630 : 560;
    const availablePanelHeight = Math.max(window.innerHeight - nextTop - 16, 320);
    const panelHeight = Math.min(preferredPanelHeight, availablePanelHeight);
    (_c = this.openButton) == null ? void 0 : _c.style.setProperty("top", `${Math.round(nextTop)}px`);
    (_d = this.panel) == null ? void 0 : _d.style.setProperty("top", `${Math.round(nextTop)}px`);
    (_e = this.panel) == null ? void 0 : _e.style.setProperty("height", `${Math.round(panelHeight)}px`);
    (_f = this.panel) == null ? void 0 : _f.style.setProperty("max-height", `${Math.round(panelHeight)}px`);
    (_g = this.openButton) == null ? void 0 : _g.setAttribute("data-ready", "true");
  }
  setOpen(isOpen) {
    var _a, _b, _c, _d, _e;
    if (!this.hasDrawer) return;
    this.isOpen = isOpen;
    (_a = this.openButton) == null ? void 0 : _a.setAttribute("aria-expanded", String(isOpen));
    document.body.classList.toggle("no-scroll_", isOpen);
    if (isOpen) {
      this.updatePosition();
      this.previouslyFocused = document.activeElement;
      if (this.overlay) this.overlay.hidden = false;
      requestAnimationFrame(() => {
        var _a2, _b2, _c2, _d2;
        (_a2 = this.overlay) == null ? void 0 : _a2.setAttribute("data-open", "true");
        (_b2 = this.panel) == null ? void 0 : _b2.setAttribute("data-open", "true");
        (_d2 = (_c2 = this.panel) == null ? void 0 : _c2.querySelector("[data-lift-kit-promo-close]")) == null ? void 0 : _d2.focus();
      });
      return;
    }
    (_b = this.overlay) == null ? void 0 : _b.setAttribute("data-open", "false");
    (_c = this.panel) == null ? void 0 : _c.setAttribute("data-open", "false");
    window.setTimeout(() => {
      if (!this.isOpen && this.overlay) this.overlay.hidden = true;
    }, 300);
    (_e = (_d = this.previouslyFocused) == null ? void 0 : _d.focus) == null ? void 0 : _e.call(_d);
  }
}
if (!customElements.get("promo-box-lift-kit")) {
  customElements.define("promo-box-lift-kit", PromoBoxLiftKit);
}
